export default __webpack_public_path__ + "static/erp-bd4618b235233340967d4140cd18ed49.svg";